import React from 'react';

import { Button, ModalBody } from '@components';
import { useHistory } from 'react-router-dom';
import { FCWithChildren } from '@types';
import useLayoutContext from '@hooks/useLayoutContext';
import { localDayDateTime } from '@utils';

export type deviceProps = {
  username?: string;
  userType?: string;
  expiry?: string;
};

type GuestDeviceConfirmProps = {
  deviceStatus?: deviceProps;
};

const GuestDeviceConfirm: FCWithChildren<GuestDeviceConfirmProps> = ({ deviceStatus }) => {
  const history = useHistory();
  const { portalAccessUrl, guestType } = useLayoutContext();
  const expiry = localDayDateTime(deviceStatus?.expiry);

  return (
    <ModalBody>
      <div className="mb-2">
        <h2 className="text-xl">This device is already registered</h2>
      </div>
      {guestType === 'free' ? (
        <>
          <div className="flex flex-col w-full mt-2 divide-y">Expire on {expiry}.</div>
        </>
      ) : (
        <>
          <p>
            Go back and click{' '}
            <a
              href=""
              rel="noreferrer noopener"
              className="underline"
              onClick={() => history.push(portalAccessUrl('/forgot-password'))}
            >
              Forgot Username or Password
            </a>{' '}
            link to have email sent to account.
          </p>
        </>
      )}
      <div className="flex justify-center items-center">
        <Button
          className="w-24 h-8 sm:w-auto mt-3 p-2"
          variant="primary"
          onClick={() => history.goBack()}
        >
          Close
        </Button>
      </div>
    </ModalBody>
  );
};
export default GuestDeviceConfirm;
